const SearchBadge = ({ query }: { query: any }) => {
	const hasQuery = query && Boolean(Object.values(query).filter((value: any) => value).length);

	return (
		<>
			<i className="bi bi-funnel me-0"></i>
			Tìm kiếm nâng cao
			{hasQuery && (
				<span className="badge badge-circle badge-warning spaces w-20 h-20 ml-4">
					{Object.keys(query).length}
				</span>
			)}
		</>
	);
};

export default SearchBadge;
